import { Helmet } from 'react-helmet';

import Video from '../components/Home/Video';
import ProductsRange from '../components/Home/ProductsRange';
import CustomersSay from '../components/Home/CustomersSay';
import FindOut from '../components/Home/FindOut';
import OurStory from '../components/Home/OurStory';
import Supplier from '../components/Home/Supplier';

function Home() {
  return (
    <div className="home__container full-horizon">
      <Helmet>
        <meta charSet="utf-8" />
        <title>라이프스팬 - 관절 건강을 위한 자연 영양제</title>
      </Helmet>
      <section className="home__section">
        <Video />
      </section>
      <section className="home__section">
        <ProductsRange />
      </section>
      <section className="home__section">
        <CustomersSay />
      </section>
      <section className="home__section">
        <FindOut />
      </section>
      <section className="home__section">
        <OurStory />
      </section>
      <section className="home__section">
        <Supplier />
      </section>
    </div>
  );
}

export default Home;
